'use client';

import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { EPlatform } from '@/utils/enums/platform-enum';
import { RightArrowOutlined } from '@zeelool/icon';
import Link from 'next/link';
import { useContext } from 'react';
import TrackOrderItem from './TrackOrderItem';
import { useTranslations } from '@/i18n/use-translations';

// 订单列表数据类型
interface OrderListData {
  id: string | number;
  created_at?: string;
  order_no?: string;
  product_images?: Array<{
    image_url: string;
    is_glass: number;
    product_info?: any;
    lens_info?: any;
  }>;
  payable?: number;
  item_count?: number;
  delivery_time?: string;
  currency?: {
    symbol: string;
    full_symbol: string;
  };
  now_currency: string;
  [key: string]: any;
}

interface TrackOrderListProps {
  orderList: OrderListData[];
  loading?: boolean;
  className?: string;
  onOrderClick?: (order: OrderListData) => void;
}

export default function TrackOrderList({
  orderList,
  loading = false,
  className = '',
  onOrderClick,
}: TrackOrderListProps) {
  const t = useTranslations('track-order.orderList');
  const { deviceType } = useContext(ResponsiveContext);
  const isWeb = deviceType === EPlatform.WEB;

  if (loading) {
    return (
      <div className={`${className} ${isWeb ? 'mt-[40px]' : 'mt-[20px]'}`}>
        {/* 加载状态 */}
        <div className="flex items-center justify-center py-[40px]">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-purple" />
        </div>
      </div>
    );
  }

  return (
    <div className={`w-full ${className} ${isWeb ? 'mt-[20px]' : 'mt-[20px] px-14'}`}>
      {/* header */}

      <div className="w-full flex items-center justify-between mb-12">
        <span className="font-bb text-18">{t('myOrders')}</span>
        <Link
          prefetch={false}
          href="/account/my-orders"
          className="flex items-center gap-[4px] text-auxiliary-text text-13"
        >
          {isWeb ? t('showAll') : t('all')} <RightArrowOutlined />
        </Link>
      </div>

      {/* PC 端布局 */}
      {isWeb && (
        <div className="space-y-[20px]">
          {orderList.map((order, index) => (
            <TrackOrderItem
              key={order.id || index}
              order={order}
              isWeb
              onOrderClick={onOrderClick}
            />
          ))}
        </div>
      )}

      {/* 移动端布局 */}
      {!isWeb && (
        <div className="space-y-[16px]">
          {orderList.map((order, index) => (
            <TrackOrderItem
              key={order.id || index}
              order={order}
              isWeb={false}
              onOrderClick={onOrderClick}
            />
          ))}
        </div>
      )}
    </div>
  );
}
